


const GoogleRouteTracker = (props) => {
    window.dataLayer.push({
        event: "VirtualPageView",
        "VirtualPageURL": props.location.pathname
    });
    return null;
};

export default GoogleRouteTracker;


// WEBPACK FOOTER //
// ./src/components/GoogleRouteTracker.js